const locations = [
  { area: 'Regional NSW, VIC, TAS & QLD', desc: 'Properties in large regional towns and communities, close to local shops, transport links, and essential services.' },
  { area: 'Sydney, NSW', desc: 'Metro properties positioned near train stations, Westfield shopping centres, and daily amenities.' },
  { area: 'Brisbane, QLD', desc: 'Well-connected accommodation close to bus routes, supermarkets, and community facilities.' },
  { area: 'Melbourne, VIC', desc: 'Conveniently located homes with access to trams, trains, local markets, and urban services.' },
];

export default function LocationAdvantages() {
  return (
    <section className="py-24 bg-navy-800">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="w-full h-[420px] rounded-lg overflow-hidden">
            <img
              src="https://static.readdy.ai/image/18ca25ea8a69d5eb1e849ccadbb7687f/2100a22bc78f11e401711bfbf9e05dc4.jpeg"
              alt="Galaxy Housing regional and metro locations across Australia"
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Text */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-0.5 bg-gold-400" />
              <span className="text-gold-400 text-sm font-medium tracking-widest uppercase">Our Locations</span>
            </div>
            <h2 className="font-heading text-4xl font-bold text-white leading-tight mb-5">
              Regional Areas &amp; Major Cities
            </h2>
            <p className="text-white/65 text-base leading-relaxed mb-8">
              Galaxy Housing operates primarily across large regional areas and towns, with a growing presence in major Australian cities. All properties are carefully selected for their proximity to public transport, supermarkets, pharmacies, and everyday essentials — because convenience matters wherever you live.
            </p>

            <div className="space-y-4">
              {locations.map((loc) => (
                <div key={loc.area} className="flex items-start gap-4 bg-navy-900/60 rounded-lg p-4 border border-white/10">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-gold-500/20 text-gold-400 shrink-0 mt-0.5">
                    <i className="ri-map-pin-2-fill text-sm" />
                  </div>
                  <div>
                    <p className="font-semibold text-white text-sm mb-0.5">{loc.area}</p>
                    <p className="text-white/55 text-sm leading-snug">{loc.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
